module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_9005.9ae2a1d5.png";